import React, { Fragment } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Card, CardBody, CardHeader, Col, Container, Row, Label, Collapse, Table, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';
import Flatpickr from "react-flatpickr";
import dateFormat from "dateformat";
import moment from "moment";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import { createDeepClone } from "../utils/index";

import CardLoader from "../components/CardLoader";
import ActionList from "../components/ActionList";
import Lookup from "../components/Lookup";
import MyDateRenderer from "../components/MyDateRenderer";
import CustomerLookup from "../components/CustomerLookup";
import { Highlighter, Menu, MenuItem } from 'react-bootstrap-typeahead';
import ConfirmModal from "../components/ConfirmModal";
import ConfirmModalAdvanced from "../components/ConfirmModalAdvanced";
import GoogleMapModal from "../components/GoogleMapModal";
import IdiServiceDocumentGrid from "../components/IdiServiceDocumentGrid";
import CommentGrid from "../components/CommentGrid";
import ErrorModal from "../components/ErrorModal";

import { useDispatch, useSelector } from "react-redux";
import * as idiProjectActions from "../actions/IdiProjectActions";
import * as commonActions from "../actions/CommonActions";

const IdiProjectEditScreen  = (props) => {
    const { register, clearErrors, reset, trigger, formState: { errors } } = useForm({mode: 'all'});

    const navigate = useNavigate();
    const { id } = useParams();

    const dispatch = useDispatch();

    const loading = useSelector((state) => state.idi.loadingFBO);
    const user = useSelector((state) => state.login.user);
    const fbo = useSelector((state) => state.idi.fbo);

    const [fboState, setFBOState] = React.useState(fbo);
    const [isDirty, setIsDirty] = React.useState(false);
    const [refreshAction, setRefreshAction] = React.useState(false);
    const [selectedCustomer, setSelectedCustomer] = React.useState([]);
    const [selectedOwner, setSelectedOwner] = React.useState([]);

    const [loadingLocal, setLoadingLocal] = React.useState(false);
    const [currentStatus, setCurrentStatus] = React.useState("");
    const [currentMessage, setCurrentMessage] = React.useState("");
    const [currentReason, setCurrentReason] = React.useState("");
    
    const [showSubmitModal, setShowSubmitModal] = React.useState(false);
    const [showDesignReviewModal, setShowDesignReviewModal] = React.useState(false);
    const [showDesignReviewAcceptedModal, setShowDesignReviewAcceptedModal] = React.useState(false);
    const [showDesignReviewRejectedModal, setShowDesignReviewRejectedModal] = React.useState(false);
    const [showDesignReviewRejectedMissingDocumentModal, setShowDesignReviewRejectedMissingDocumentModal] = React.useState(false);
    const [showDesignReviewRejectedCancelledModal, setShowDesignReviewRejectedCancelledModal] = React.useState(false);
    const [showUploadedToBaladyModal, setShowUploadedToBaladyModal] = React.useState(false);
    const [showMoveToNextStateModal, setShowMoveToNextStateModal] = React.useState(false);
    const [showSkipToNextStateModal, setShowSkipToNextStateModal] = React.useState(false);
    const [showMoveToPreviousStateModal, setShowMoveToPreviousStateModal] = React.useState(false);
    const [showCompletedModal, setShowCompletedModal] = React.useState(false);
    const [showClosedModal, setShowClosedModal] = React.useState(false);
    const [showCancelledModal, setShowCancelledModal] = React.useState(false);
    const [showAbortedModal, setShowAbortedModal] = React.useState(false);
    const [showAssignMeModal, setShowAssignMeModal] = React.useState(false);
        
    const [activeTab, setActiveTab] = React.useState(0);
    const [showGoogleMap, setShowGoogleMap] = React.useState(false);
    
    const [addInspectionProjectId, setAddInspectionProjectId] = React.useState("");
    const [addInspectionStateName, setAddInspectionStateName] = React.useState("");
    const [addInspectionVisitType, setAddInspectionVisitType] = React.useState("");
    const [showAddInspectionConfirmModal, setShowAddInspectionConfirmModal] = React.useState(false);
    const [showAddInspectionModal, setShowAddInspectionModal] = React.useState(false);

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    React.useEffect(() => {
	    dispatch(idiProjectActions.loadIdiProject(id, navigate));
    }, [id]);

    React.useEffect(() => {
		setFBOState(fbo);
        setIsDirty(false);
        setRefreshAction(!refreshAction);
        setSelectedCustomer([]);
        setSelectedOwner([]);

        if(fbo) {
            
        }
        
        if(fbo != null) {
            reset(fbo.idiProject);
            
            if(fbo.customer != null) {
                setSelectedCustomer([fbo.customer]);
            }

            if(fbo.owner != null) {
                setSelectedOwner([fbo.owner]);
            }

            if(fbo.currentStageIndex != -1) {
                setActiveTab(fbo.currentStageIndex);
            }
            else {
                setActiveTab(0);
            }
        }
        
        clearErrors();
    }, [fbo]);

    const reloadAction = () => {
        setRefreshAction(!refreshAction);
    }

    const onChangeDocument = (isProduct) => {
        setRefreshAction(!refreshAction);
    }

    const getFormattedDate = (value) => {
        if(value) {
            return dateFormat(value, "mm/dd/yyyy");
        }
        return "";
    }

    const getFormattedDateTime = (value) => {
        if(value) {
            return dateFormat(value, "mm/dd/yyyy HH:MM");
        }
        return "";
    }

    const getDateWithoutTimezone = (value) => {
        if(value) {
            const tzoffset = value.getTimezoneOffset() * 60000;
            const withoutTimezone = new Date(value.valueOf() - tzoffset).toISOString().slice(0, -1);
            return withoutTimezone;
        }
        return "";
    }

    const onIdiProjectChange = (name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "projectCost" || name === "locationLatitude" || name === "locationLongitude") {
                value = value.replace(/[^0-9.-]/g, '').replace(/(?!^)-/g, '').replace(/(\..*)\./g, '$1');
            }
            
            copy_fboState.idiProject[name] = value;
        }
        else if(value === false) {
            copy_fboState.idiProject[name] = false;
        }
        else {
            copy_fboState.idiProject[name] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onCoordinatorChange = (value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.idiProject["coordinatorUserId"] = null;
        }
        else {
            copy_fboState.idiProject["coordinatorUserId"] = value;
        }
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onDesignTeamChange = (value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.idiProject["designTeamUserId"] = null;
        }
        else {
            copy_fboState.idiProject["designTeamUserId"] = value;
        }
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onIdiProjectAddressSelect = (locationData) => {
        if(locationData) {
            var copy_fboState = createDeepClone(fboState);

            copy_fboState.idiProject["locationAddress"] = locationData.address;
            copy_fboState.idiProject["locationCountry"] = locationData.country;
            copy_fboState.idiProject["locationCity"] = locationData.city;
            copy_fboState.idiProject["locationState"] = locationData.state;
            copy_fboState.idiProject["locationZipCode"] = locationData.zipCode;
            copy_fboState.idiProject["locationLatitude"] = locationData.latitude;
            copy_fboState.idiProject["locationLongitude"] = locationData.longitude;

            setFBOState(copy_fboState);
            setIsDirty(true);
            setShowGoogleMap(false);
        }
    }

    const onCustomerChange = (item) => {
        var copy_fboState = createDeepClone(fboState);
        setSelectedCustomer(item);
        
        if(item.length > 0) {
            copy_fboState.idiProject["customerId"] = item[0].id.toString();
        }
        else {
            copy_fboState.idiProject["customerId"] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onOwnerChange = (item) => {
        var copy_fboState = createDeepClone(fboState);
        setSelectedOwner(item);
        
        if(item.length > 0) {
            copy_fboState.idiProject["ownerId"] = item[0].id.toString();
        }
        else {
            copy_fboState.idiProject["ownerId"] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onInspectionAdd = (projectId, stateName, visitType) => {
        setAddInspectionProjectId(projectId);
        setAddInspectionStateName(stateName);
        setAddInspectionVisitType(visitType);
        setShowAddInspectionConfirmModal(true);
    }

    const onAddInspectionClick = async () => {
        var valid = true;
        if(valid) {
            setLoadingLocal(true);
            var data = await idiProjectActions.addInspectionToIdiProject(addInspectionProjectId, addInspectionStateName, addInspectionVisitType);
            setLoadingLocal(false);

            if(data.success) {
                dispatch(commonActions.setSuccessMessage(data.successMessage));
                dispatch(idiProjectActions.loadIdiProject(fboState.idiProject.id, navigate));
                setShowAddInspectionModal(false);
            }
            else{
                dispatch(commonActions.setErrorMessage(data.errorMessage));
            }

            reloadAction();
        }
    }

    const hideAddInspectionConfirmModal = () => {
        setShowAddInspectionConfirmModal(false);
        setShowAddInspectionModal(true);
    }

    const hideAddInspectionModal = () => {
        setShowAddInspectionConfirmModal(false);
        setShowAddInspectionModal(false);
    }

    const onSaveIdiProject = async(skipValidation) => {
        var valid = true;

        if(currentStatus === "Rejected" || currentStatus === "Missing Documents" || currentStatus === "Reviewed & Cancelled") {
            if(!currentMessage || currentMessage.length === 0) {
                dispatch(commonActions.setErrorMessage("Please Enter Any Reason/Comments/Notes"));
                return;
            }
        }

        if(!skipValidation) {
            valid = await trigger();
        }
         
        if(valid) {
            dispatch(idiProjectActions.saveIdiProject(fboState, currentStatus, currentMessage, navigate));
        }

        onCloseModalClick();
    }

    const onCancelIdiProject = () => {
        setFBOState(fbo);

        if(fbo.customer != null) {
            setSelectedCustomer([fbo.customer]);
        }
        else {
            setSelectedCustomer([]);
        }

        if(fbo.owner != null) {
            setSelectedOwner([fbo.owner]);
        }
        else {
            setSelectedOwner([]);
        }

        setIsDirty(false);
        clearErrors();
    }

    const onSubmitIdiProjectClick = () => {
        setCurrentStatus("New");
        setCurrentMessage("");
        setShowSubmitModal(true);
    }

    const onDesignReviewIdiProjectClick = () => {
        setCurrentStatus("Design Review");
        setCurrentMessage("");
        setShowDesignReviewModal(true);
    }

    const onDesignReviewAcceptedIdiProjectClick = () => {
        setCurrentStatus("Accepted");
        setCurrentMessage("");
        setShowDesignReviewAcceptedModal(true);
    }

    const onDesignReviewRejectedIdiProjectClick = () => {
        setCurrentStatus("Rejected");
        setCurrentMessage("");
        setShowDesignReviewRejectedModal(true);
    }

    const onDesignReviewRejectedMissingDocumentIdiProjectClick = () => {
        setCurrentStatus("Missing Documents");
        setCurrentMessage("");
        setShowDesignReviewRejectedMissingDocumentModal(true);
    }

    const onDesignReviewRejectedCancelledIdiProjectClick = () => {
        setCurrentStatus("Reviewed & Cancelled");
        setCurrentMessage("");
        setShowDesignReviewRejectedCancelledModal(true);
    }

    const onUploadedToBaladyIdiProjectClick = () => {
        setCurrentStatus("Uploaded To Balady");
        setCurrentMessage("");
        setShowUploadedToBaladyModal(true);
    }

    const onMoveToNextStateIdiProjectClick = () => {
        setCurrentStatus("Next");
        setCurrentMessage("");
        setShowMoveToNextStateModal(true);
    }

    const onSkipToNextStateIdiProjectClick = () => {
        setCurrentStatus("SkipNext");
        setCurrentMessage("");
        setShowSkipToNextStateModal(true);
    }

    const onMoveToPreviousStateIdiProjectClick = () => {
        setCurrentStatus("Previous");
        setCurrentMessage("");
        setShowMoveToPreviousStateModal(true);
    }

    const onCompletedIdiProjectClick = () => {
        setCurrentStatus("Completed");
        setCurrentMessage("");
        setShowCompletedModal(true);
    }

    const onClosedIdiProjectClick = () => {
        setCurrentStatus("Closed");
        setCurrentMessage("");
        setShowClosedModal(true);
    }

    const onCancelledIdiProjectClick = () => {
        setCurrentStatus("Cancelled");
        setCurrentMessage("");
        setShowCancelledModal(true);
    }

    const onAbortedIdiProjectClick = () => {
        setCurrentStatus("Aborted");
        setCurrentMessage("");
        setShowAbortedModal(true);
    }

    const onAssignMeProjectClick = () => {
        setShowAssignMeModal(true);
    }

    const onAssignMeProject = async () => {
        dispatch(idiProjectActions.assignIdiProject(fboState.idiProject.id, user.id, true, navigate));
        onCloseModalClick();
    }

    const onCloseModalClick = () => {
        setCurrentStatus("");
        setCurrentMessage("");
        setCurrentReason("");

        setShowSubmitModal(false);
        setShowDesignReviewModal(false);
        setShowDesignReviewAcceptedModal(false);
        setShowDesignReviewRejectedModal(false);
        setShowDesignReviewRejectedMissingDocumentModal(false);
        setShowDesignReviewRejectedCancelledModal(false);
        setShowUploadedToBaladyModal(false);
        setShowMoveToNextStateModal(false);
        setShowSkipToNextStateModal(false);
        setShowMoveToPreviousStateModal(false);
        setShowCompletedModal(false);
        setShowClosedModal(false);
        setShowCancelledModal(false);
        setShowAbortedModal(false);
        setShowAssignMeModal(false);

        setShowGoogleMap(false);
        setShowAddInspectionConfirmModal(false);
        setShowAddInspectionModal(false);
    }
    
    const CustomerRenderer = (results, menuProps, props) => (
        <Menu id="menuCustomerLookup" style={{minWidth:600}}>
            <div className="container">
                <div className="row font-weight-bold border-bottom">
                    <div className="col">Code</div>
                    <div className="col">Name</div>
                    <div className="col">Email</div>
                    <div className="col">Address</div>
                </div>
            </div>
            {results.length == 0 && <div style={{padding:5}}>No Macthes Found...</div>}
            {results.map((result, idx) => (
                <MenuItem
                    key={idx}
                    option={result}
                    position={idx}>
                    <div className="row border-bottom">
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.code || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.fullName || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.email || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.fullAddress || ""}
                            </Highlighter>
                        </div>
                    </div>
                </MenuItem>
            ))}
        </Menu>
    )

    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={`Edit IDI Project`} />
                    <Row>
                        <Col lg={9}>
                            <CardLoader loading={loading || loadingLocal} />

                            <Card className="mb-0">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">
                                        IDI Project
                                    </h5>
                                    <div className="flex-shrink-1 ms-3">
                                        <div className="d-flex flex-wrap gap-2">
                                            {fboState && fboState.canSave &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || !isDirty}
                                                onClick={() => onSaveIdiProject(true)}
                                            >
                                                <i className="ri-save-line label-icon align-middle"></i> Save IDI Project
                                            </button>
                                            }
                                            {fboState && fboState.canSave &&
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading || !isDirty}
                                                onClick={onCancelIdiProject}
                                            >
                                                <i className="ri-close-line label-icon align-middle"></i> Cancel
                                            </button>
                                            }
                                            {fboState && fboState.canSubmit &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onSubmitIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Submit to Design Review
                                            </button>
                                            }
                                            {fboState && fboState.canDesignReview &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onDesignReviewIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Send To Design Review
                                            </button>
                                            }
                                            {fboState && fboState.canDesignReviewAccept &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onDesignReviewAcceptedIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Accept Design Review
                                            </button>
                                            }
                                            {fboState && fboState.canDesignReviewReject &&
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading}
                                                onClick={() => onDesignReviewRejectedIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Reject Design Review
                                            </button>
                                            }
                                            {fboState && fboState.canDesignReviewReject &&
                                            <button className="btn btn-outline-danger btn-label"
                                                disabled={loading}
                                                onClick={() => onDesignReviewRejectedMissingDocumentIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Reject(Missing Document) Design Review
                                            </button>
                                            }
                                            {fboState && fboState.canDesignReviewReject &&
                                            <button className="btn btn-outline-danger btn-label"
                                                disabled={loading}
                                                onClick={() => onDesignReviewRejectedCancelledIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Reviewed & Cancelled
                                            </button>
                                            }
                                            {fboState && fboState.canUploadedToBalady &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onUploadedToBaladyIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Uploaded To Balady
                                            </button>
                                            }
                                            {fboState && fboState.canMoveToNextState &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onMoveToNextStateIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isUploadedToBalady ? "Balady Accepted / Tawuniya INS Initiated" : "Move to Next State" + (fboState && fboState.nextStageName ? (" (" + fboState.nextStageName + ")") : "")}
                                            </button>
                                            }
                                            {fboState && fboState.canSkipToNextState &&
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading}
                                                onClick={() => onSkipToNextStateIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Skip to Next State {fboState && fboState.nextStageName ? (" (" + fboState.nextStageName + ")") : ""}
                                            </button>
                                            }
                                            {fboState && fboState.canMoveToPreviousState &&
                                            <button className="btn btn-outline-primary btn-label"
                                                disabled={loading}
                                                onClick={() => onMoveToPreviousStateIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Move to Previous State {fboState && fboState.previousStageName ? (" (" + fboState.previousStageName + ")") : ""}
                                            </button>
                                            }
                                            {fboState && fboState.canCompleted &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onCompletedIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Completed
                                            </button>
                                            }
                                            {fboState && fboState.canClosed &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onClosedIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Closed
                                            </button>
                                            }
                                            {fboState && fboState.canCancelled &&
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading}
                                                onClick={() => onCancelIdiProject()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Cancelled
                                            </button>
                                            }
                                            {fboState && fboState.canAborted &&
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading}
                                                onClick={() => onAbortedIdiProjectClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Aborted
                                            </button>
                                            }
                                            {fboState && fboState.canAssignMe &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || loadingLocal}
                                                onClick={() => onAssignMeProjectClick()}
                                            >
                                                <i className="ri-user-follow-line label-icon align-bottom"></i> Assign Me IDI Project
                                            </button>
                                            }
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Project #</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(fboState && fboState.idiProject.projectNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Current Stage</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(fboState && fboState.idiProject.status) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Lot Ref #<span className="required">*</span></Label>
                                            <input type="text" maxLength={256} className={`form-control ${errors.lotRefNo ? "is-invalid" : ""}`} readOnly={fboState && fboState.canSave ? false : true}
                                                title={errors.lotRefNo?.message}
                                                value={(fboState && fboState.idiProject.lotRefNo) || ""}
                                                {...register("lotRefNo", { required: "Lot Ref # is required" })}
                                                onChange={e => onIdiProjectChange("lotRefNo", e.target.value, false)}
                                            />
                                        </Col>
                                        {fboState && fboState.idiProject.statusReason &&
                                        <Fragment>
                                            <Col xxl={12} md={12}>
                                                <div class="alert alert-danger" role="alert">
                                                    <b>{(fboState && fboState.idiProject.statusReason) || ""}</b> : {(fboState && fboState.idiProject.statusMessage) || ""}
                                                </div>
                                            </Col>
                                        </Fragment>
                                        }
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Coordinator User</Label>
                                            <select className="form-select" disabled={fboState && fboState.canSave ? false : true}
                                                value={(fboState && fboState.idiProject.coordinatorUserId) || ""}
                                                onChange={e => onCoordinatorChange(e.target.value)}
                                            >
                                                <option value={0}>...</option>
                                                {fboState && fboState.coordinatorUserList.map(function(item, index){
                                                    return (
                                                        <option key={index} value={item.id}>{item.fullName}</option>
                                                    );
                                                })}
                                            </select>
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Design Review User</Label>
                                            <select className="form-select" disabled={fboState && fboState.canSave ? false : true}
                                                value={(fboState && fboState.idiProject.designTeamUserId) || ""}
                                                onChange={e => onDesignTeamChange(e.target.value)}
                                            >
                                                <option value={0}>...</option>
                                                {fboState && fboState.designTeamUserList.map(function(item, index){
                                                    return (
                                                        <option key={index} value={item.id}>{item.fullName}</option>
                                                    );
                                                })}
                                            </select>
                                        </Col>
                                        <Col xxl={4}>&nbsp;</Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Source Name<span className="required">*</span></Label>
                                            <select className={`form-select ${errors.sourceName ? "is-invalid" : ""}`} disabled={fboState && fboState.canSave ? false : true}
                                                title={errors.sourceName?.message}
                                                value={(fboState && fboState.idiProject.sourceName) || ""}
                                                {...register("sourceName", { required: "Source Name is required" })}
                                                onChange={e => onIdiProjectChange("sourceName", e.target.value, false)}
                                            >
                                                <option value="">...</option>
                                                <option value="Tawuniya">Tawuniya</option>
                                                <option value="Balady">Balady</option>
                                            </select>
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Tawuniya Ref #{fboState && (fboState.idiProject.sourceName === "Tawuniya" || fboState.isUploadedToBalady) && <span className="required">*</span>}</Label>
                                            <input type="text" maxLength={256} className={`form-control ${errors.tawuniyaRefNo ? "is-invalid" : ""}`} readOnly={fboState && fboState.canSave ? false : true}
                                                title={errors.tawuniyaRefNo?.message}
                                                value={(fboState && fboState.idiProject.tawuniyaRefNo) || ""}
                                                {...register("tawuniyaRefNo", { 
                                                    validate: (value) => {
                                                        if (fboState && (fboState.idiProject.sourceName === "Tawuniya" || fboState.isUploadedToBalady) && !value) {
                                                            return "Tawuniya Ref # is required";
                                                        }

                                                        return true;
                                                    }
                                                })}
                                                onChange={e => onIdiProjectChange("tawuniyaRefNo", e.target.value, false)}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Balady Ref #{fboState && fboState.idiProject.sourceName === "Balady" && <span className="required">*</span>}</Label>
                                            <input type="text" maxLength={256} className={`form-control ${errors.baladyRefNo ? "is-invalid" : ""}`} readOnly={fboState && fboState.canSave ? false : true}
                                                title={errors.baladyRefNo?.message}
                                                value={(fboState && fboState.idiProject.baladyRefNo) || ""}
                                                {...register("baladyRefNo", { 
                                                    validate: (value) => {
                                                        if (fboState && fboState.idiProject.sourceName === "Balady" && !value) {
                                                            return "Balady Ref # is required";
                                                        }

                                                        return true;
                                                    }
                                                })}
                                                onChange={e => onIdiProjectChange("baladyRefNo", e.target.value, false)}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Request For Proposal</Label>
                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canSave ? false : true}
                                                value={(fboState && fboState.idiProject.requestForProposal) || ""}
                                                onChange={e => onIdiProjectChange("requestForProposal", e.target.value, false)}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Project Type<span className="required">*</span></Label>
                                            <select className={`form-select ${errors.projectType ? "is-invalid" : ""}`} disabled={fboState && fboState.canSave ? false : true}
                                                title={errors.projectType?.message}
                                                value={(fboState && fboState.idiProject.projectType) || ""}
                                                {...register("projectType", { required: "Project Type is required" })}
                                                onChange={e => onIdiProjectChange("projectType", e.target.value, false)}
                                            >
                                                <option value="">...</option>
                                                <option value="Normal">Normal</option>
                                                <option value="Fast Track">Fast Track</option>
                                            </select>
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Structure Type<span className="required">*</span></Label>
                                            <select className={`form-select ${errors.structureType ? "is-invalid" : ""}`} disabled={fboState && fboState.canSave ? false : true}
                                                title={errors.structureType?.message}
                                                value={(fboState && fboState.idiProject.structureType) || ""}
                                                {...register("structureType", { required: "Structure Type is required" })}
                                                onChange={e => onIdiProjectChange("structureType", e.target.value, false)}
                                            >
                                                <option value="">...</option>
                                                <option value="Rein. Concrete">Rein. Concrete</option>
                                                <option value="Steel Structure">Steel Structure</option>
                                                <option value="Mix: Steel & Concrete">Mix: Steel & Concrete</option>
                                                <option value="Post-tensioned">Post-tensioned</option>
                                                <option value="Pre-tensioned">Pre-tensioned</option>
                                                <option value="StrType_7">StrType_7</option>
                                            </select>
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Project Cost<span className="required">*</span></Label>
                                            <input type="text" className={`form-control ${errors.projectCost ? "is-invalid" : ""}`} readOnly={fboState && fboState.canSave ? false : true}
                                                title={errors.projectCost?.message}
                                                value={(fboState && fboState.idiProject.projectCost) || ""}
                                                {...register("projectCost", { required: "Project Cost is required" })}
                                                onChange={e => onIdiProjectChange("projectCost", e.target.value, false)}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Currency<span className="required">*</span></Label>
                                            <select className={`form-select ${errors.currencyName ? "is-invalid" : ""}`} disabled={fboState && fboState.canSave ? false : true}
                                                title={errors.currencyName?.message}
                                                value={(fboState && fboState.idiProject.currencyName) || ""}
                                                {...register("currencyName", { required: "Currency is required" })}
                                                onChange={e => onIdiProjectChange("currencyName", e.target.value, false)}
                                            >
                                                <option value={""}>...</option>
                                                <option value="AED">UAE Dirham</option>
                                                <option value="CNY">China Yuan</option>
                                                <option value="EUR">Euro</option>
                                                <option value="USD">USA Dollar</option>
                                                <option value="LKR">Sri Lanka Rupee</option>
                                                <option value="EGP">Egypt Pound</option>
                                                <option value="SAR">Saudi Riyal</option>
                                                <option value="INR">India Rupee</option>
                                            </select>
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Region<span className="required">*</span></Label>
                                            <select className={`form-select ${errors.region ? "is-invalid" : ""}`} disabled={fboState && fboState.canSave ? false : true}
                                                title={errors.region?.message}
                                                value={(fboState && fboState.idiProject.region) || ""}
                                                {...register("region", { required: "Region is required" })}
                                                onChange={e => onIdiProjectChange("region", e.target.value, false)}
                                            >
                                                <option value="">...</option>
                                                <option value="Abha - Southern Region">Abha - Southern Region</option>
                                                <option value="Abqaiq - Eastern Region">Abqaiq - Eastern Region</option>
                                                <option value="Al Ahsa - Eastern Region">Al Ahsa - Eastern Region</option>
                                                <option value="Al Bahah - Western Region">Al Bahah - Western Region</option>
                                                <option value="Al Jawf - Central Region">Al Jawf - Central Region</option>
                                                <option value="Al Jubail - Eastern Region">Al Jubail - Eastern Region</option>
                                                <option value="Al Khafji - Eastern Region">Al Khafji - Eastern Region</option>
                                                <option value="Al Kharj - Central Region">Al Kharj - Central Region</option>
                                                <option value="Al Khobar - Eastern Region">Al Khobar - Eastern Region</option>
                                                <option value="Al Nuairiyah - Eastern Region">Al Nuairiyah - Eastern Region</option>
                                                <option value="Al Qassim - Central Region">Al Qassim - Central Region</option>
                                                <option value="Al Qatif - Eastern Region">Al Qatif - Eastern Region</option>
                                                <option value="Al Riyadh - Central Region">Al Riyadh - Central Region</option>
                                                <option value="Araar - Central Region">Araar - Central Region</option>
                                                <option value="Aseer - Western Region">Aseer - Western Region</option>
                                                <option value="Dammam - Eastern Region">Dammam - Eastern Region</option>
                                                <option value="Dawadmi - Central Region">Dawadmi - Central Region</option>
                                                <option value="Dhahran - Eastern Region">Dhahran - Eastern Region</option>
                                                <option value="Hafar Al Batin - Eastern Region">Hafar Al Batin - Eastern Region</option>
                                                <option value="Hail - Central Region">Hail - Central Region</option>
                                                <option value="Jazan - Western Region">Jazan - Western Region</option>
                                                <option value="Jeddah - Western Region">Jeddah - Western Region</option>
                                                <option value="Makkah - Western Region">Makkah - Western Region</option>
                                                <option value="Medina - Western Region">Medina - Western Region</option>
                                                <option value="Najran - Western Region">Najran - Western Region</option>
                                                <option value="Nairan - Central Region">Nairan - Central Region</option>
                                                <option value="Qaryat Al Ulya - Eastern Region">Qaryat Al Ulya - Eastern Region</option>
                                                <option value="Rafha - Central Region">Rafha - Central Region</option>
                                                <option value="Ras Tanura - Eastern Region">Ras Tanura - Eastern Region</option>
                                                <option value="Sakaka - Central Region">Sakaka - Central Region</option>
                                                <option value="Tabuk - Western Region">Tabuk - Western Region</option>
                                                <option value="Taif - Western Region">Taif - Western Region</option>
                                                <option value="Turaif - Central Region">Turaif - Central Region</option>
                                            </select>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card className="mb-0">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">Location Information</h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <Col xxl={12} md={12}>
                                            <Label className="form-label">Address<span className="required">*</span></Label>
                                            <div className="d-flex gap-2">
                                                <input type="text" maxLength={256} className={`form-control ${errors.locationAddress ? "is-invalid" : ""}`} readOnly={fboState && fboState.canSave ? false : true}
                                                    title={errors.locationAddress?.message}
                                                    value={(fboState && fboState.idiProject.locationAddress) || ""}
                                                    {...register("locationAddress", { required: "Address is required" })}
                                                    onChange={e => onIdiProjectChange("locationAddress", e.target.value)}
                                                />
                                                {fboState &&
                                                <button className="btn btn-primary btn-icon float-end"
                                                    onClick={() => setShowGoogleMap(true)}
                                                >
                                                    <i className="ri-map-pin-line"></i>
                                                </button>
                                                }
                                            </div>
                                        </Col>
                                        <Col xxl={3} md={6}>
                                            <Label className="form-label">Country<span className="required">*</span></Label>
                                            <input type="text" maxLength={256} className={`form-control ${errors.locationCountry ? "is-invalid" : ""}`} readOnly={fboState && fboState.canSave ? false : true}
                                                title={errors.locationCountry?.message}
                                                value={(fboState && fboState.idiProject.locationCountry) || ""}
                                                {...register("locationCountry", { required: "Country is required" })}
                                                onChange={e => onIdiProjectChange("locationCountry", e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={3} md={6}>
                                            <Label className="form-label">City<span className="required">*</span></Label>
                                            <input type="text" maxLength={256} className={`form-control ${errors.locationCity ? "is-invalid" : ""}`} readOnly={fboState && fboState.canSave ? false : true}
                                                title={errors.locationCity?.message}
                                                value={(fboState && fboState.idiProject.locationCity) || ""}
                                                {...register("locationCity", { required: "City is required" })}
                                                onChange={e => onIdiProjectChange("locationCity", e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={3} md={6}>
                                            <Label className="form-label">State</Label>
                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canSave ? false : true}
                                                value={(fboState && fboState.idiProject.locationState) || ""}
                                                onChange={e => onIdiProjectChange("locationState", e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={3} md={6}>
                                            <Label className="form-label">Zip Code</Label>
                                            <input type="text" maxLength={256} className="form-control" readOnly={fboState && fboState.canSave ? false : true}
                                                value={(fboState && fboState.idiProject.locationZipCode) || ""}
                                                onChange={e => onIdiProjectChange("locationZipCode", e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={3} md={6}>
                                            <Label className="form-label">Latitude</Label>
                                            <input type="text" className="form-control" readOnly={fboState && fboState.canSave ? false : true}
                                                value={(fboState && fboState.idiProject.locationLatitude) || ""}
                                                onChange={e => onIdiProjectChange("locationLatitude", e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={3} md={6}>
                                            <Label className="form-label">Longitude</Label>
                                            <input type="text" className="form-control" readOnly={fboState && fboState.canSave ? false : true}
                                                value={(fboState && fboState.idiProject.locationLongitude) || ""}
                                                onChange={e => onIdiProjectChange("locationLongitude", e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card className="mb-0">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">Customer Information<span className="required">*</span></h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Customer</Label>
                                            {fboState && fboState.canSave &&
                                            <Fragment>
                                                <Lookup
                                                    clearButton 
                                                    allowNew ={false}
                                                    id ={`fldCustomerLookup`}
                                                    url = {`GetIdiCustomerLookup?isCustomer=1`}
                                                    defaultSearch={fboState && fboState.idiProject.customerId || ""}
                                                    placeholder= "Select Customer..."
                                                    labelKey= {option => `${option.code || ""} - ${option.fullName || ""}`}
                                                    selected = {selectedCustomer}
                                                    onChange = {(value) => onCustomerChange(value)}
                                                    renderMenu = {CustomerRenderer}
                                                    title={errors.customerId?.message}
                                                    inputProps={{
                                                        className: errors.customerId ? (selectedCustomer.length > 0 ? "" : "is-invalid") : ""
                                                    }}
                                                />
                                                <input type="hidden"
                                                    value={fboState && fboState.idiProject.customerId || ""} readOnly={true}
                                                    {...register("customerId", { required: "Customer is required" })} 
                                                />
                                            </Fragment>
                                            }
                                            {fboState && !fboState.canSave &&
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && (selectedCustomer[0].code + " - " + selectedCustomer[0].fullName)) || ""}
                                            />
                                            }
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Name</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].fullName) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Email</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].email) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Phone Number</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].telephoneNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Mobile Number</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].mobileNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Fax Number</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].faxNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={12} md={12}>
                                            <Label className="form-label">Address</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedCustomer.length > 0 && selectedCustomer[0].fullAddress) || ""}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card className="mb-3">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">Owner Information<span className="required">*</span></h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Owner Code</Label>
                                            {fboState && fboState.canSave &&
                                            <Fragment>
                                                <Lookup
                                                    clearButton 
                                                    allowNew ={false}
                                                    id ={`fldCustomerLookup`}
                                                    url = {`GetIdiCustomerLookup?isOwner=1`}
                                                    defaultSearch={fboState && fboState.idiProject.ownerId || ""}
                                                    placeholder= "Select Owner..."
                                                    labelKey= {option => `${option.code || ""} - ${option.fullName || ""}`}
                                                    selected = {selectedOwner}
                                                    onChange = {(value) => onOwnerChange(value)}
                                                    renderMenu = {CustomerRenderer}
                                                    title={errors.ownerId?.message}
                                                    inputProps={{
                                                        className: errors.ownerId ? (selectedOwner.length > 0 ? "" : "is-invalid") : ""
                                                    }}
                                                />
                                                <input type="hidden"
                                                    value={fboState && fboState.idiProject.ownerId || ""} readOnly={true}
                                                    {...register("ownerId", { required: "Owner is required" })} 
                                                />
                                            </Fragment>
                                            }
                                            {fboState && !fboState.canSave &&
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedOwner.length > 0 && (selectedOwner[0].code + " - " +selectedOwner[0].fullName)) || ""}
                                            />
                                            }
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Name</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedOwner.length > 0 && selectedOwner[0].fullName) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Email</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedOwner.length > 0 && selectedOwner[0].email) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Phone Number</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedOwner.length > 0 && selectedOwner[0].telephoneNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Mobile Number</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedOwner.length > 0 && selectedOwner[0].mobileNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Fax Number</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedOwner.length > 0 && selectedOwner[0].faxNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={12} md={12}>
                                            <Label className="form-label">Address</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedOwner.length > 0 && selectedOwner[0].fullAddress) || ""}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            
                            {fboState && fboState.showStage &&
                            <Card className="mt-3 mb-3">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">Stage(s)</h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                                            {fboState && fboState.idiProject.stateList.length === 0 && <Col xxl={12} md={12}><Label className="form-label">No Stage(s) added.</Label></Col>}
                                            <Nav tabs className="nav nav-tabs nav-tabs-custom arrow-navtabs nav-success nav-justified mb-3" style={{ flexWrap: "nowrap", minWidth: "max-content" }}>
                                                {fboState && fboState.idiProject.stateList.map(function(state, stateIndex){
                                                    return (
                                                        <NavItem key={stateIndex}>
                                                            <NavLink style={{ cursor: "pointer" }} className={activeTab === stateIndex ? "active" : ""} onClick={() => { toggleTab(stateIndex); }} >
                                                                <div className="d-flex align-items-center">
                                                                    <div style={{display: "flex", flexDirection: "column"}}>
                                                                        <span>
                                                                            State #
                                                                        </span>
                                                                        <span style={{whiteSpace: "nowrap"}}>
                                                                            {state.stateName}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </NavLink>
                                                        </NavItem>
                                                    );
                                                })}
                                            </Nav>
                                        </div>
                                        <TabContent activeTab={activeTab} className="text-muted">
                                            {fboState && fboState.idiProject.stateList.map(function(state, stateIndex){
                                                return (
                                                    <TabPane tabId={stateIndex} key={stateIndex}>
                                                        {state.skipped &&
                                                        <Row className="gy-2">
                                                            <Col xxl={12} md={12}>
                                                                <div class="alert alert-danger" role="alert">
                                                                    <b>{state.stateName} state is skipped</b>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        }
                                                        {(!state.skipped || state.inspectionList.length > 0) &&
                                                        <Row className="gy-2">
                                                            <Col xxl={12} md={12}>
                                                                <Card className="mb-0 card-light">
                                                                    <CardHeader className="border-0 d-flex align-items-center">
                                                                        <h5 className="card-title mb-0 flex-grow-1">{state.stateName} Inspections</h5>
                                                                        <div className="flex-shrink-0">
                                                                            <div className="d-flex flex-wrap gap-2">
                                                                                {state.canAddInspection &&
                                                                                <button className="btn btn-primary me-1"
                                                                                    onClick={() => onInspectionAdd(fboState.idiProject.id, state.stateName)}
                                                                                >
                                                                                    <i className="ri-save-line align-bottom me-1"></i> Add Inspection
                                                                                </button>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </CardHeader>
                                                                    <CardBody className="border border-dashed border-end-0 border-start-0 p-0">
                                                                        <Row className="gy-2">
                                                                            <Col xxl={12} md={12}>
                                                                                <div className="table-responsive">
                                                                                    <Table className="table-hover table-bordered align-middle mb-0">
                                                                                        <thead className="table-primary">
                                                                                            <tr>
                                                                                                <th>Inspection #</th>
                                                                                                <th>Visit Type</th>
                                                                                                <th>Status</th>
                                                                                                <th>Start Date</th>
                                                                                                <th>End Date</th>
                                                                                                <th>Report Type</th>
                                                                                                <th>Last Action</th>
                                                                                                <th className="text-center">View Details</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {state.inspectionList.length == 0 && <tr><td colSpan={8}>No Inspection(s) Added</td></tr>}
                                                                                            {state.inspectionList.map(function(item, index){
                                                                                                return(
                                                                                                    <tr key={index}>
                                                                                                        <td>{item.inspectionNumber}</td>
                                                                                                        <td>{item.visitType}</td>
                                                                                                        <td><span className="badge" style={{backgroundColor: item.statusColorCode}}>{item.statusName}</span></td>
                                                                                                        <td><MyDateRenderer value={item.startDate} /></td>
                                                                                                        <td><MyDateRenderer value={item.endDate} /></td>
                                                                                                        <td>
                                                                                                            {item.isRd5Report && <span className="badge bg-primary me-1">RD5</span>}
                                                                                                            {item.isRd7Report && <span className="badge bg-secondary me-1">RD7</span>}
                                                                                                            {item.isInrReport && <span className="badge bg-success me-1">INR</span>}
                                                                                                            {item.isRd3Report && <span className="badge bg-danger me-1">RD3</span>}
                                                                                                            {item.isRd6Report && <span className="badge bg-warning me-1">RD6</span>}
                                                                                                            {item.isBaladyReport && <span className="badge bg-info me-1">BALADY</span>}
                                                                                                            {item.isNoReport && <span className="badge bg-light me-1">NO REPORT</span>}
                                                                                                        </td>
                                                                                                        <td><MyDateRenderer value={item.lastActionDate} /></td>
                                                                                                        <td className="text-center">
                                                                                                            <Link to={`/idi-inspection-edit/${item.id}`}>
                                                                                                                <i className="ri-eye-line align-bottom me-2" /> View
                                                                                                            </Link>
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                );
                                                                                            })}
                                                                                        </tbody>
                                                                                    </Table>
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    </CardBody>
                                                                </Card>
                                                            </Col>
                                                            <Col xxl={12} md={12}>
                                                                <IdiServiceDocumentGrid 
                                                                    serviceId={-14}
                                                                    refId={state.id}
                                                                    refName={"IDI_PROJECT_STATE"}
                                                                    parentId={fboState.idiProject.id}
                                                                    parentName={"IDI_PROJECT"}
                                                                    isProduct={false}
                                                                    refreshAction={refreshAction}
                                                                    collapsed={"false"}
                                                                    canChange={state.canAddInspection}
                                                                    onChange={onChangeDocument}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        }
                                                    </TabPane>
                                                );
                                            })}
                                        </TabContent>
                                    </Row>
                                </CardBody>
                            </Card>
                            }
                            {fboState && fboState.showFinalReport &&
                            <Card className="mb-3">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">Final Reports</h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <Col xxl={12} md={12}>
                                            <div className="table-responsive">
                                                <Table className="table-hover table-bordered align-middle mb-0">
                                                    <thead className="table-primary">
                                                        <tr>
                                                            <th>Inspection #</th>
                                                            <th>Status</th>
                                                            <th>Report Type</th>
                                                            <th>Last Action</th>
                                                            <th className="text-center">View Details</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {fboState.idiProject.inspectionList.length == 0 && <tr><td colSpan={6}>No Inspection(s) Added</td></tr>}
                                                        {fboState.idiProject.inspectionList.map(function(item, index){
                                                            return(
                                                                <tr key={index}>
                                                                    <td>{item.inspectionNumber}</td>
                                                                    <td><span className="badge" style={{backgroundColor: item.statusColorCode}}>{item.statusName}</span></td>
                                                                    <td>
                                                                        {item.isRd5Report && <span className="badge bg-primary me-1">RD5</span>}
                                                                        {item.isRd7Report && <span className="badge bg-secondary me-1">RD7</span>}
                                                                        {item.isInrReport && <span className="badge bg-success me-1">INR</span>}
                                                                        {item.isRd3Report && <span className="badge bg-danger me-1">RD3</span>}
                                                                        {item.isRd6Report && <span className="badge bg-warning me-1">RD6</span>}
                                                                        {item.isBaladyReport && <span className="badge bg-info me-1">BALADY</span>}
                                                                        {item.isNoReport && <span className="badge bg-light me-1">NO REPORT</span>}
                                                                    </td>
                                                                    <td><MyDateRenderer value={item.lastActionDate} /></td>
                                                                    <td className="text-center">
                                                                        <Link to={`/idi-inspection-edit/${item.id}`}>
                                                                            <i className="ri-eye-line align-bottom me-2" /> View
                                                                        </Link>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            }
                            {fboState && fboState.idiProject.id > 0 &&
                                <IdiServiceDocumentGrid 
                                    serviceId={-13}
                                    refId={fboState.idiProject.id}
                                    refName={"IDI_PROJECT"}
                                    parentId={fboState.idiProject.id}
                                    parentName={"IDI_PROJECT"}
                                    isProduct={false}
                                    refreshAction={refreshAction}
                                    collapsed={"false"}
                                    canChange={fboState.canSave}
                                    onChange={onChangeDocument}

                                    showStructuralDocument={fboState.showStructuralDocument}
                                    canEditStructuralDocument={fboState.canEditStructuralDocument}
                                    isStructuralDocumentRequired={fboState.isStructuralDocumentRequired}

                                    showStructuralModelDocument={fboState.showStructuralModelDocument}
                                    canEditStructuralModelDocument={fboState.canEditStructuralModelDocument}
                                    isStructuralModelDocumentRequired={fboState.isStructuralModelDocumentRequired}

                                    showArchitecturalDocument={fboState.showArchitecturalDocument}
                                    canEditArchitecturalDocument={fboState.canEditArchitecturalDocument}
                                    isArchitecturalDocumentRequired={fboState.isArchitecturalDocumentRequired}

                                    showSoilDocument={fboState.showSoilDocument}
                                    canEditSoilDocument={fboState.canEditSoilDocument}
                                    isSoilDocumentRequired={fboState.isSoilDocumentRequired}

                                    showAutoCadDocument={fboState.showAutoCadDocument}
                                    canEditAutoCadDocument={fboState.canEditAutoCadDocument}
                                    isAutoCadDocumentRequired={fboState.isAutoCadDocumentRequired}

                                    showCalculationDocument={fboState.showCalculationDocument}
                                    canEditCalculationDocument={fboState.canEditCalculationDocument}
                                    isCalculationDocumentRequired={fboState.isCalculationDocumentRequired}

                                    showWaterproofingDocument={fboState.showWaterproofingDocument}
                                    canEditWaterproofingDocument={fboState.canEditWaterproofingDocument}
                                    isWaterproofingDocumentRequired={fboState.isWaterproofingDocumentRequired}

                                    showRd0Document={fboState.showRd0Document}
                                    canEditRd0Document={fboState.canEditRd0Document}
                                    isRd0DocumentRequired={fboState.isRd0DocumentRequired}

                                    showDrrDocument={fboState.showDrrDocument}
                                    canEditDrrDocument={fboState.canEditDrrDocument}
                                    isDrrDocumentRequired={fboState.isDrrDocumentRequired}

                                    showRd5Document={fboState.showRd5Document}
                                    showRd7Document={fboState.showRd7Document}
                                    showInspectionDocument={fboState.showInspectionDocument}
                                    showRd3Document={fboState.showRd3Document}
                                    showRd6Document={fboState.showRd6Document}
                                    showBaladyDocument={fboState.showBaladyDocument}
                                />
                            }

                            {fboState && fboState.idiProject.id > 0 &&
                                <CommentGrid refId={fboState.idiProject.id} refName="IDI_PROJECT" onCommentAdd={reloadAction} />
                            }
                        </Col>
                        
                        {fboState && fboState.idiProject.id > 0 &&
                        <Col lg={3}>
                            <ActionList id={fboState.idiProject.id} name={"IDI_PROJECT"} refreshAction={refreshAction} />
                        </Col>
                        }

                        <ConfirmModal message={"Are you sure the site is ready and the location has been verified?"} show={showAddInspectionConfirmModal} onCloseClick={hideAddInspectionModal} onYesClick={hideAddInspectionConfirmModal} />

                        <Modal tabIndex="-1" size="xl" isOpen={showAddInspectionModal} toggle={hideAddInspectionModal} centered={true}>
                            <ModalHeader>
                                Add {addInspectionStateName} Inspection
                            </ModalHeader>
                            <ModalBody>
                                <CardLoader loading={loadingLocal} />
                                <Row className="gy-2">
                                    <Col xxl={3} md={3}>
                                        <label className="form-label">State Name</label>
                                        <input className="form-control" readOnly={true}
                                            value={addInspectionStateName}
                                            onChange={e => setAddInspectionStateName(e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={3} md={3}>
                                        <label className="form-label">Visit Type</label>
                                        <select className="form-select"
                                            value={addInspectionVisitType}
                                            onChange={e => setAddInspectionVisitType(e.target.value)}
                                        >
                                            <option value="">...</option>
                                            <option value="Usual Visit">Usual Visit</option>
                                            <option value="Re-Visit">Re-Visit</option>
                                            <option value="Additional Visit">Additional Visit</option>
                                            <option value="Usual Visit – Portal">Usual Visit – Portal</option>
                                            <option value="RD7">RD7</option>
                                            <option value="ADV Not RD5">ADV Not RD5</option>
                                            <option value="RD5">RD5</option>
                                            <option value="RD0">RD0</option>
                                            <option value="Rescheduled by Client">Rescheduled by Client</option>
                                            <option value="Not on Portal">Not on Portal</option>
                                        </select>
                                    </Col>
                                </Row>
                            </ModalBody>
                            <ModalFooter>
                                <button type="button" className="btn btn-primary btn-label" onClick={onAddInspectionClick} disabled={loadingLocal}>
                                    <i className="ri-save-line label-icon align-bottom"></i> Add Inspection
                                </button>
                                <button type="button" className="btn btn-danger btn-label" data-dismiss="modal" onClick={hideAddInspectionModal} disabled={loadingLocal}>
                                    <i className="ri-close-line label-icon align-bottom"></i> Close
                                </button>
                            </ModalFooter>
                        </Modal>

                        <ConfirmModal message={"Are you sure you want to submit the IDI Project for \"Design Review\"?"} show={showSubmitModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)} />
                        <ConfirmModal message={"Are you sure you want to move the IDI Project to \"Design Review\"?"} show={showDesignReviewModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)} />
                        <ConfirmModal message={"Are you sure you want to mark the IDI Project as \"Design Review Accepted\"?"} show={showDesignReviewAcceptedModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)} />
                        <ConfirmModalAdvanced show={showDesignReviewRejectedModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)}>
                            <div className="text-center pb-2">Are you sure you want to mark the IDI Project as "Design Review Rejected with Notes"?</div>
                            <Col xxl={12} md={12} className="pb-2">
                                <Label className="form-label">Enter Any Reason/Comments/Notes</Label>
                                <textarea className="form-control" rows="5"
                                    value={currentMessage || ""}
                                    onChange={e => setCurrentMessage(e.target.value)}
                                />
                            </Col>
                        </ConfirmModalAdvanced>
                        <ConfirmModalAdvanced show={showDesignReviewRejectedMissingDocumentModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)}>
                            <div className="text-center pb-2">Are you sure you want to mark the IDI Project as "Design Review Rejected with Missing Documents"?</div>
                            <Col xxl={12} md={12} className="pb-2">
                                <Label className="form-label">Enter Any Reason/Comments/Notes</Label>
                                <textarea className="form-control" rows="5"
                                    value={currentMessage || ""}
                                    onChange={e => setCurrentMessage(e.target.value)}
                                />
                            </Col>
                        </ConfirmModalAdvanced>
                        <ConfirmModalAdvanced show={showDesignReviewRejectedCancelledModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)}>
                            <div className="text-center pb-2">Are you sure you want to mark the IDI Project as "Reviewed & Cancelled"?</div>
                            <Col xxl={12} md={12} className="pb-2">
                                <Label className="form-label">Enter Any Reason/Comments/Notes</Label>
                                <textarea className="form-control" rows="5"
                                    value={currentMessage || ""}
                                    onChange={e => setCurrentMessage(e.target.value)}
                                />
                            </Col>
                        </ConfirmModalAdvanced>
                        <ConfirmModal message={"Are you sure you want to mark the IDI Project as \"Uploaded To Balady\"?"} show={showUploadedToBaladyModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)} />
                        <ConfirmModal message={"Are you sure you want to move the IDI Project to the \"Next State\"?"} show={showMoveToNextStateModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)} />
                        <ConfirmModal message={"Are you sure you want to skip the IDI Project to the \"Next State\"?"} show={showSkipToNextStateModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)} />
                        <ConfirmModal message={"Are you sure you want to move the IDI Project to the \"Previous State\"?"} show={showMoveToPreviousStateModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)} />
                        <ConfirmModal message={"Are you sure you want to mark the IDI Project as \"Completed\"?"} show={showCompletedModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)} />
                        <ConfirmModal message={"Are you sure you want to mark the IDI Project as \"Closed\"?"} show={showClosedModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)} />
                        <ConfirmModal message={"Are you sure you want to mark the IDI Project as \"Cancelled\"?"} show={showCancelledModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)} />
                        <ConfirmModal message={"Are you sure you want to mark the IDI Project as \"Aborted\"?"} show={showAbortedModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiProject(false)} />
                        <ConfirmModal message={"Are you sure you want to \"Assign\" the IDI Project?"} show={showAssignMeModal} onCloseClick={onCloseModalClick} onYesClick={onAssignMeProject} />
                    </Row>
                </Container>
            </div>

            {fboState && showGoogleMap &&
            <GoogleMapModal
                show={showGoogleMap}
                onYesClick={onIdiProjectAddressSelect}
                onCloseClick={() => setShowGoogleMap(false)} 
                address={fboState.idiProject.locationAddress || ""}
                latitude={fboState.idiProject.locationLatitude || null}
                longitude={fboState.idiProject.locationLongitude || null}
            />
            }
        </Fragment>
    );
}

export default IdiProjectEditScreen;